import "core-js/modules/es.array.concat";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import _objectSpread from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import IconShare from '@tencent/vft-component/IconShare';
import { setShare } from '@vip-activity/business/pageSetting';
import _env from '@tencent/vft-common/env';
import pop from '@/mixin/pop';
import { cutStrWithEmoji } from '@/util';
import config from '@/config';
export default {
  mixins: [pop],
  components: {
    IconShare: IconShare,
    CloudSealCard: function CloudSealCard() {
      return import('@tencent/cloud-seal-card');
    }
  },
  watch: {
    visible: function visible(val) {
      setShare(val ? _objectSpread(_objectSpread({}, this.shareCfg), {}, {
        link: this.params.shareUrl.replace(/qr\./, 'pg.')
      }) : this.shareCfg, this.userService);
    }
  },
  data: function data() {
    return {
      visible: false,
      base64: '',
      shareInfo: {}
    };
  },
  computed: {
    env: function env() {
      return _env;
    },
    shareCfg: function shareCfg() {
      var 魂力分享 = this.setting.魂力分享;
      var shareSetting = null;

      if (!this.visible) {
        shareSetting = window.pageSetting;
      } else {
        shareSetting = 魂力分享;
      }

      var _shareSetting = shareSetting,
          分享标题 = _shareSetting.分享标题,
          分享描述 = _shareSetting.分享描述,
          分享朋友圈标题 = _shareSetting.分享朋友圈标题,
          分享图 = _shareSetting.分享图,
          分享链接 = _shareSetting.分享链接;
      return {
        timeLineTitle: 分享朋友圈标题,
        imgUrl: 分享图,
        title: 分享标题,
        desc: 分享描述,
        link: 分享链接
      };
    },
    params: function params() {
      var _this$userService = this.userService,
          nick = _this$userService.nick,
          headurl = _this$userService.headurl;
      var vipIcon = this.vipService.vipIcon;
      var params = {};
      var _this$shareInfo = this.shareInfo,
          starName = _this$shareInfo.starName,
          starSrc = _this$shareInfo.starSrc,
          starid = _this$shareInfo.starid,
          propsCount = _this$shareInfo.propsCount,
          allCount = _this$shareInfo.allCount;
      Object.assign(params, {
        starName: starName,
        starSrc: starSrc,
        propsCount: propsCount,
        allCount: allCount,
        level: vipIcon,
        nick: cutStrWithEmoji(nick, 12),
        headImg: headurl,
        shareUrl: "".concat(config.shareLink, "?ptag=qr.props&starid=").concat(starid)
      });
      params.qrUrl = params.shareUrl;
      console.log(params);
      return params;
    },
    sealCardId: function sealCardId() {
      return 'u64TkQqr8L';
    }
  },
  methods: {
    success: function success(img) {
      this.base64 = img;
      console.log('card img success.');
    },
    close: function close() {
      this.base64 = '';
      this.visible = false;
    },
    bindEvent: function bindEvent() {
      var _this = this;

      this.eventBus.$on('launchPropsShare', function (data) {
        _this.visible = true;
        _this.shareInfo = data;
      });
    }
  },
  mounted: function mounted() {
    this.bindEvent();
  }
};